export const initialAndFinalDateTextInputReportForm = {
  data: () => ({
    datetimestart: new Date(),
    datetimeend: new Date(),
    dateProps: {
      locale: 'pt-br',
      color: 'bluePcm',
    },
    timeProps: {
      color: 'bluePcm',
      scrollable: true,
      format: '24hr',
    },
    textProps: {
      dense: true,
      outlined: true,
    },
  }),

  async created() {
    this.datetimestart.setHours(0)
    this.datetimestart.setMinutes(0)
    this.datetimeend.setHours(23)
    this.datetimeend.setMinutes(59)
  },

  methods: {
    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },
  },
}
